const MyCoursesLoading = () => {
    return (
      <div className="mt-4 w-full px-4 space-y-3">
        {[1, 2, 3].map((index) => (
          <div
            key={index}
            className="rounded-lg bg-content3 w-full flex overflow-hidden p-4 gap-4 items-center"
          >
            <div className="aspect-square w-1/4 bg-content4 rounded-lg animate-pulse"></div>
            <div className="flex-1 space-y-2">
              <div className="h-4 bg-content4 rounded w-3/4 animate-pulse"></div>
              <div className="h-3 bg-content4 rounded w-1/2 animate-pulse"></div>
              <div className="h-3 bg-content4 rounded w-2/3 animate-pulse"></div>
            </div>
          </div>
        ))}
      </div>
    );
  };
  
  export default MyCoursesLoading;
  